import StandardModal from "./StandardModal"
export default StandardModal
